// extracted by mini-css-extract-plugin
export default {"heading":"Header_heading__Vk-8O","subheading":"Header_subheading__eEXwy"};